import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-slate-800 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 flex items-center justify-center bg-gradient-to-br from-teal-500 to-emerald-600 rounded-xl">
                <i className="ri-heart-pulse-line text-white text-xl"></i>
              </div>
              <div>
                <div className="font-bold text-base">DT1 Simply Menu</div>
                <div className="text-teal-400 text-xs">Gestion glucidique</div>
              </div>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed mb-5">
              Votre assistant nutritionnel pour diabétiques de type 1 sous boucle fermée. Calculez vos glucides, obtenez votre Nutri-Score et gérez votre alimentation en toute simplicité.
            </p>
            <div className="flex items-center gap-3">
              {['ri-facebook-line', 'ri-twitter-x-line', 'ri-instagram-line', 'ri-youtube-line'].map((icon) => (
                <a
                  key={icon}
                  href="#"
                  className="w-9 h-9 flex items-center justify-center rounded-full border border-slate-600 text-slate-400 hover:border-teal-500 hover:text-teal-400 transition-colors cursor-pointer"
                >
                  <i className={`${icon} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-semibold text-sm uppercase tracking-wider text-slate-300 mb-4">Navigation</h4>
            <ul className="space-y-3">
              {[
                { path: '/', label: 'Accueil' },
                { path: '/plat-personnalise', label: 'Plat Personnalisé' },
                { path: '/info-aliment', label: 'Info Aliment' },
                { path: '/contact', label: 'Contact' },
              ].map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-slate-400 hover:text-teal-400 text-sm transition-colors cursor-pointer flex items-center gap-2"
                  >
                    <i className="ri-arrow-right-s-line text-teal-500"></i>
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact & Disclaimer */}
          <div>
            <h4 className="font-semibold text-sm uppercase tracking-wider text-slate-300 mb-4">Contact</h4>
            <ul className="space-y-3 mb-6">
              <li className="flex items-center gap-3 text-slate-400 text-sm">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-mail-line text-teal-400"></i>
                </div>
                contact@dt1symply.lbtdesign.fr
              </li>
              <li className="flex items-center gap-3 text-slate-400 text-sm">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-phone-line text-teal-400"></i>
                </div>
                +33 1 23 45 67 89
              </li>
            </ul>
            <div className="bg-amber-900/30 border border-amber-700/40 rounded-lg p-3">
              <div className="flex items-start gap-2">
                <div className="w-4 h-4 flex items-center justify-center mt-0.5 shrink-0">
                  <i className="ri-information-line text-amber-400 text-sm"></i>
                </div>
                <p className="text-amber-300/80 text-xs leading-relaxed">
                  <strong>Avertissement médical :</strong> Ce site est un outil d&apos;aide à la gestion des glucides. Il ne remplace pas l&apos;avis d&apos;un professionnel de santé.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="border-t border-slate-700">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-slate-500 text-xs">© 2025 DT1 Simply Menu. Tous droits réservés.</p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-slate-500 hover:text-slate-400 text-xs cursor-pointer">Mentions légales</a>
            <a href="#" className="text-slate-500 hover:text-slate-400 text-xs cursor-pointer">Politique de confidentialité</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
